// What a Company is, the single best description its own captured pages give.
// Ported from main's website-classification enum
// (`script/signal/11-website-research.ts`). Distinct from the consumer
// product's `CompanyType`.
export enum CompanyProfileType {
  SOLAR_INSTALLER = "solar_installer",
  ELECTRICAL_CONTRACTOR = "electrical_contractor",
  ROOFING_CONTRACTOR = "roofing_contractor",
  GENERAL_CONTRACTOR = "general_contractor",
  HVAC_CONTRACTOR = "hvac_contractor",
  SOLAR_CLEANING = "solar_cleaning",
  MANUFACTURER = "manufacturer",
  FINANCIER = "financier",
  DISTRIBUTOR = "distributor",
  CONSULTING = "consulting",
  OTHER = "other",
}

export const dataByCompanyProfileType: Record<
  CompanyProfileType,
  { label: string }
> = {
  [CompanyProfileType.SOLAR_INSTALLER]: { label: "Solar installer" },
  [CompanyProfileType.ELECTRICAL_CONTRACTOR]: {
    label: "Electrical contractor",
  },
  [CompanyProfileType.ROOFING_CONTRACTOR]: { label: "Roofing contractor" },
  [CompanyProfileType.GENERAL_CONTRACTOR]: { label: "General contractor" },
  [CompanyProfileType.HVAC_CONTRACTOR]: { label: "HVAC contractor" },
  [CompanyProfileType.SOLAR_CLEANING]: { label: "Solar cleaning" },
  [CompanyProfileType.MANUFACTURER]: { label: "Manufacturer" },
  [CompanyProfileType.FINANCIER]: { label: "Financier" },
  [CompanyProfileType.DISTRIBUTOR]: { label: "Distributor" },
  [CompanyProfileType.CONSULTING]: { label: "Consulting" },
  [CompanyProfileType.OTHER]: { label: "Other" },
}
